import React from 'react';

const ProfileIcon = () => {
    return (
        <svg width={23.579} height={26.524} viewBox="0 0 23.579 26.524">
            <g transform="translate(1 1)">
                <path
                    d="M21.579 24.524v-2.7a5.4 5.4 0 00-5.395-5.392H5.395A5.4 5.4 0 000 21.827v2.7"
                    fill="none"
                    stroke="#8f99dc"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2px"
                />
                <circle
                    cx={5.5}
                    cy={5.5}
                    r={5.5}
                    transform="translate(4.934)"
                    fill="none"
                    stroke="#8f99dc"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2px"
                />
            </g>
        </svg>
    );
};

export default ProfileIcon;
